// Etiqueta "Novo" das Novidades: estado partilhado entre o sidebar e a página.
// O "visto até" (maior id de release_note já visto) fica no localStorage,
// por schema e por utilizador; é por browser, não sincroniza entre PCs.
import { computed, reactive } from "vue";
import axios from "axios";

const baseURL = process.env.VUE_APP_URL_BASE;

function chave() {
  let userId = 0;
  try {
    userId = JSON.parse(localStorage.getItem("user"))?.id || 0;
  } catch (e) {
    userId = 0;
  }
  const schema = localStorage.getItem("selectedSchema") || "safetycv";
  return `novidades_visto_ate:${schema}:${userId}`;
}

function lerVistoAte() {
  try {
    return Number(localStorage.getItem(chave())) || 0;
  } catch (e) {
    return 0;
  }
}

export const novidades = reactive({ recentes: [], maxId: 0, vistoAte: 0 });

export const novidadesPorVer = computed(
  () => novidades.recentes.filter((id) => id > novidades.vistoAte).length,
);

export async function carregarResumoNovidades() {
  try {
    const { data } = await axios.get(`${baseURL}/api/v1/release-notes/resumo/`);
    novidades.recentes = data.data?.recentes || [];
    novidades.maxId = data.data?.max_id || 0;
  } catch (error) {
    novidades.recentes = [];
  }
  novidades.vistoAte = lerVistoAte();
}

export function marcarNovidadesVistas() {
  if (novidades.maxId <= novidades.vistoAte) return;
  novidades.vistoAte = novidades.maxId;
  try {
    localStorage.setItem(chave(), String(novidades.maxId));
  } catch (e) {
    // sem localStorage a etiqueta volta a aparecer na próxima visita
  }
}
